/* eslint-disable promise/param-names */
import { AUTH_REQUEST, AUTH_REQUEST_TUTOR, AUTH_ERROR, AUTH_SUCCESS, AUTH_LOGOUT,LOGIN_AS,REVERT } from '../actions/auth'
import { USER_REQUEST } from '../actions/user'

import {router} from "../../main.js"
import graphqlClient from '../gqlclient';
function getRoleFromJWT (token) {
  var base64Url = token.split('.')[1];
  var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  var jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
  }).join(''));
jwt=JSON.parse(jsonPayload);
  return jwt['https://hasura.io/jwt/claims']['X-Hasura-Role']
};

const state = {  status: '', hasLoadedOnce: false }

const getters = {
  isAuthenticated: state => !!state.isAuthenticated,
  authStatus: state => state.status,
loggedInAs:state => state.loggedInAs,
loggedInPartner:state => state.loggedInPartner,
  getAuth: state => state
}

const actions = {
  [AUTH_REQUEST]: ({commit, dispatch}, user) => {
    return new Promise((resolve, reject) => {
      commit(AUTH_REQUEST)
graphqlClient.query({query:require('../../components/Login/login.gql'),variables:{username:user.username.trim(),password:user.password},fetchPolicy:'no-cache'})
.then(res => {
  console.log('auth_request',res)
if(res.errors){
  reject(res)
}
  localStorage.setItem('jwt_token', res.data.login.accessToken)
        //localStorage.setItem('refetch_token', resp.data.refetch_token)
        commit(AUTH_SUCCESS, res)
       
        console.log('done login')
        resolve(res)
})

    })
  },
  [AUTH_LOGOUT]: ({commit, dispatch}) => {
    return new Promise((resolve, reject) => {
      commit(AUTH_LOGOUT)
      document.cookie = "jwt_token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
      localStorage.removeItem('jwt_token')
      localStorage.removeItem('loginas_jwt_token')
      localStorage.removeItem('vuex')
      localStorage.removeItem('refetch_token')
      router.push('/login')
      resolve()
    })
  },
  [LOGIN_AS]:({commit, dispatch},partner) => {
    return new Promise((resolve, reject) => {
     
      //get the partner
      graphqlClient.query({query:require('../../components/Login/getPartner.gql'),variables:partner,fetchPolicy:'no-cache',headers:{authorisation:`${token}`}})
      .then(res => {
        console.log(res)
commit(LOGIN_AS,res.data.partner_by_pk.name)
      }); 
      const token = window.localStorage.getItem('jwt_token')
      graphqlClient.query({query:require('../../components/Login/loginas.gql'),variables:partner,fetchPolicy:'no-cache',headers:{authorisation:`${token}`}})
      .then(res => {
        console.log('login_as',res.data.loginas.accessToken)
        localStorage.setItem('loginas_jwt_token', res.data.loginas.accessToken);
        console.log('done login as')
        resolve(res)
      })
    })
  },
  [REVERT]:({commit}) => {
    return new Promise((resolve, reject) => {
    localStorage.removeItem('loginas_jwt_token')
    commit(REVERT)
    resolve(true)
    })
  }
}

const mutations = {
  [AUTH_REQUEST]: (state) => {
    state.status = 'loading'
  },
  [AUTH_SUCCESS]: (state, resp) => {
    console.log('auth_suucess')
    console.log(resp)

    state.status = 'success'
    state.isAuthenticated = true
    //state.token = resp.data.login.accessToken
    state.hasLoadedOnce = true
    state.id = resp.data.login.user_id
    state.firstname =resp.data.login.firstname

    state.partner=resp.data.login.partner_id
  },
  [AUTH_ERROR]: (state) => {
    state.status = 'error'
    state.hasLoadedOnce = true
  },
  [LOGIN_AS]:(state,partner) => {
    state.loggedInAs = true
    state.loggedInPartner = partner
  },
  [AUTH_LOGOUT]: (state) => {
    
    state.isAuthenticated = false
    state.loggedInAs = false
    state.loggedInPartner = ""
  },
  [REVERT]: (state) => {
    
    state.loggedInAs = false

    state.loggedInPartner = ""
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/auth.js